export default {"src":"/_next/static/media/META.f88a6b59.svg","height":18,"width":18};